import { PartnerFinanceMonthReport } from 'types/partnerFinance';
import {
  createPartnerFinanceMonthBillIncomeMock,
  createPartnerFinanceMonthRewardIncomeMock,
} from './partnerFinanceMonthIncomeUtils';
import { subMonths } from 'date-fns';

export function createPartnerFinanceMonthReport(): PartnerFinanceMonthReport {
  return {
    monthDateISO: '',
    earnedAmount: 0,
    paidAmount: 0,
    incomes: [],
  };
}

export function createPartnerFinanceMonthReportMock(
  monthNumber: number = 0
): PartnerFinanceMonthReport {
  return {
    monthDateISO: subMonths(new Date(), monthNumber).toISOString(),
    earnedAmount: 300,
    paidAmount: 150,
    incomes: [
      createPartnerFinanceMonthBillIncomeMock(),
      createPartnerFinanceMonthBillIncomeMock(),
      createPartnerFinanceMonthRewardIncomeMock(),
      createPartnerFinanceMonthBillIncomeMock(),
    ],
  };
}
